import history from 'utils/history';

import { findIndex, isEqual } from 'lodash';

import moment from 'moment';

import PropTypes from 'prop-types';

import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import { Progress } from 'reactstrap';

import { createStructuredSelector } from 'reselect';

import SmallLoadingIndicator from 'atoms/SmallLoadingIndicator';
import AdultSubstanceAbuse from 'components/AdultSubstanceAbuse';
import BehavioralGuidelines from 'components/BehavioralGuidelines';
import ChildBasicInfo from 'components/ChildBasicInfo';
import CommonHeader from 'components/CommonHeader';
import DrugAlcoholPolicy from 'components/DrugAlcoholPolicy';
import Footer from 'components/Footer';
import GroupStandards from 'components/GroupStandards';
import GroupTherapyConsentFrom from 'components/GroupTherapyConsentFrom';
import LoadingIndicator from 'components/LoadingIndicator';
import StatusModal from 'components/RequestSentModal';
import SigningModal from 'components/SigningModal';
import {
	fetchCities,
	fetchStates,
	fetchZipcodes,
} from 'containers/App/actions';
import {
	makeSelectAuth,
	makeSelectCities,
	makeSelectIsMobile,
	makeSelectStates,
	makeSelectZipcodes,
} from 'containers/App/selectors';
import makeSelectGeo from 'containers/Geo/selectors';
import makeSelectPatientRegister from 'containers/PatientRegister/selectors';
import AdultMedical from 'pages/intake/adult/Medical';
import AdultMedicalContinued from 'pages/intake/adult/MedicalContinued';
import AdultMedicalHistory from 'pages/intake/adult/MedicalHistory';
import AdultOtherHistory from 'pages/intake/adult/OtherHistory';
import AdultPsychiatricHistory from 'pages/intake/adult/PsychiatricHistory';
import AdultSleepHabits from 'pages/intake/adult/SleepHabits';
import ChildAdhdInfo from 'pages/intake/child/AdhdInfo';
import ChildAppointmentReason from 'pages/intake/child/AppointmentReason';
import ChildOtherIntake from 'pages/intake/child/OtherIntake';
import ChildSleepHabits from 'pages/intake/child/SleepHabits';
import Acknowledgements from 'pages/intake/shared/Acknowledgements';
import AuthorizeToSharePHI from 'pages/intake/shared/AuthorizeToSharePhi';
import FinancialAgreementIntake from 'pages/intake/shared/FinancialAgreement';
import InsuranceIntake from 'pages/intake/shared/Insurance';
import PrimaryCareIntake from 'pages/intake/shared/PrimaryCare';
import PrivacyPracticesIntake from 'pages/intake/shared/PrivacyPractices';
import IntakeQuestionnaire from 'pages/intake/shared/Questionnaire';
import Telehealth from 'pages/intake/shared/Telehealth';
import { isProduction } from 'utils/constants';
import PatientPayment from 'v2/routes/intake/PatientPayment';
import IopIntake from 'v2/routes/intake/PatientPaymentIOP';

import {
	checkOnboading,
	docCreate,
	docSign,
	fetchData,
	patientIntake,
	setPrevPath,
} from './actions';
import {
	STEPS,
	adultSteps,
	childSteps,
	iopPhpSteps,
	lastSigningStep,
	patientFinalStep,
} from './constants';
import './index.css';
import makeSelectPatientIntake, {
	makeSelectCreateDocSuccess,
	makeSelectCreatingDoc,
} from './selectors';
import { stateFields } from './state';

// While the signing modal is open (embedded or in a new tab), poll the
// verified onboarding gate so the patient is moved on automatically once the
// backend records the completed signature.
const ONBOARDING_POLL_MS = 4000;
// Ceiling on how long we'll poll a single signing session before giving up, so
// an abandoned/blocked session doesn't poll forever while the page stays
// mounted. ~15 minutes at the 4s interval (225 ticks).
const MAX_POLL_ATTEMPTS = 225;

// Watchdog on the blocking signing spinner. If neither a signing URL nor an
// error arrives within this window, force a visible error + retry so a failure
// mode nobody classified (the 2026-08-07 incident, where the submit request
// never reached the server) still degrades visibly instead of stranding the
// patient on the spinner forever.
//
// MUST stay ABOVE the axios client timeout in utils/api.js (currently 60000ms):
// on a plain request timeout the real, better-classified error wins the race at
// ~60s and produces its specific message, so this generic watchdog only fires
// when even that path fails to surface. Changing one constant constrains the
// other — keep this comment and utils/api.js's timeout in sync.
const SIGNING_WATCHDOG_MS = 75000;

// Shown when the watchdog fires. Deliberately worded differently from the
// classified-error copy so support can tell "we don't know what happened" apart
// from a specific, classified failure in a patient's screenshot.
const WATCHDOG_ERROR_MESSAGE =
	'We could not confirm your signing request went through. Please try again, or contact the clinic if this keeps happening.';

// Fallback for a classified signing failure that somehow arrived without a
// message string.
const SIGNING_ERROR_FALLBACK =
	'We could not complete your signing request. Please try again.';

/* eslint-disable react/prefer-stateless-function */
export class Intake extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			siteUrl: '',
			signingInNewTab: false,
			popupBlocked: false,
			pollTimedOut: false,
			// The gate and the upload spinner both read the Redux creatingDoc /
			// createDocSuccess flags now — the former duplicate component copies (and
			// the never-set-true createDocSuccess dead branch) are gone. waitingOnDocCb
			// carries the follow-up callback of a final-step click held during a slow
			// create, so the queued docSign survives the drain.
			waitingOnDoc: false,
			waitingOnDocData: {},
			waitingOnDocCb: null,
			maxProgress: 15,
			currentProgress: 0,
			primaryCareChecked: false,
			therapistChecked: false,
			insuranceInformationreChecked: false,
			drugAlcoholPolicyChecked: false,
			behavioralGuideLinesChecked: false,
			cancellationPolicyChecked: false,
			authorizeToSharePHIChecked: false,
			groupTherapyConsentFormChecked: false,
			therapyGroupChecked: false,
			returnedCheckChecked: false,
			delinquentAccountsChecked: false,
			limitaionsOfConfidentialityChecked: false,
			mobileMsgFaxEmailChecked: false,
			MessagesChecked: false,
			emergencyAccessChecked: false,
			consentForTreatmentChecked: false,
			electronicRecordChecked: false,
			billingChecked: false,
			infoRelatedTreatmentChecked: false,
			patientAgreementChecked: false,
			openPaymentChecked: false,
			goodFaithEstimateChecked: false,
			financialAgreementChecked: false,
			IOPChecked: false,
			IOPAgreementChecked: false,
			guarantorChecked: false,
			programFee: '',
			patientPaymentDetailsChecked: false,
			patientPaymentAgreementChecked: false,
			sameAsMainAddress: false,
			privacyPracticesChecked: false,
			privacyNoticeNotSignedDescribe: '',
			authorizeToSharePHINotSignedDescribe: '',
			GroupStandardsChecked: false,
			telehealthChecked: false,
			virtualGroupChecked: false,
			loading: false,
			signingError: false,
			signingErrorMessage: '',
			useCreditCard: true,
		};
		this.toggle = this.toggle.bind(this);
		this.onboardingPollInterval = null;
		// Watchdog timer for the blocking signing spinner. Stored on the instance
		// (like onboardingPollInterval), not in state.
		this.signingWatchdog = null;
		this.pollAttempts = 0;
	}

	componentDidMount() {
		const { patientIntakeFetchData, auth } = this.props;
		const { id } = auth.loggedInUser;
		this.setState({ name: auth.loggedInUser.name });
		patientIntakeFetchData({ id });
		this.setLocalState();
		this.props.doFetchStates();

		// Quick fix - the modal is somehow setting the body's class to "modal-open"
		document.body.className = '';
	}

	componentDidUpdate(prevProps) {
		const wasComplete = this.isOnboardingComplete(prevProps);

		if (!wasComplete && this.isOnboardingComplete()) {
			// Signing verified — tear down the fallback. The Patient route reacts to
			// onboardingComplete and redirects to the dashboard on its own.
			this.stopOnboardingPolling();
			this.setState({
				modal: false,
				signingInNewTab: false,
				popupBlocked: false,
				pollTimedOut: false,
			});
		}
	}

	componentWillUnmount() {
		const { currentProgress } = this.state;
		const { doSetPrevPath } = this.props;

		if (currentProgress === 1) {
			history.push('/patient/registration');
			doSetPrevPath('Intake');
		}

		this.stopOnboardingPolling();
		this.clearSigningWatchdog();
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		// eslint-disable-next-line array-callback-return
		Object.keys(stateFields).map((comp) => {
			if (
				nextProps.patientIntakeFields.questionnaire[comp] &&
				!isEqual(
					nextProps.patientIntakeFields.questionnaire[comp],
					this.state[comp],
				) &&
				isEqual(nextState[comp], stateFields[comp])
			) {
				this.setState({
					[comp]: nextProps.patientIntakeFields.questionnaire[comp],
				});
			}
		});
		return true;
	};

	setLocalState = () => {
		// eslint-disable-next-line array-callback-return
		Object.keys(stateFields).map((comp) => {
			this.setState({
				[comp]: stateFields[comp],
			});
		});
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { maxProgress } = this.state;
		const { patientIntakeFields, createDocSuccess } = nextProps;

		if (createDocSuccess && this.state.waitingOnDoc) {
			// Doc creation finished while a final-step click was held. Replay it now,
			// carrying the callback it was captured with — dropping the callback here
			// (the pre-fix behavior) silently swallowed the queued docSign and
			// stranded the patient after a slow create. That follow-up is the blocking
			// signing request, so show the spinner and arm the watchdog exactly as the
			// direct final-step path does, keeping the "no silent spinner" invariant.
			const { waitingOnDocData, waitingOnDocCb } = this.state;
			this.saveData(waitingOnDocData, waitingOnDocCb);
			this.setState({
				waitingOnDoc: false,
				waitingOnDocData: null,
				waitingOnDocCb: null,
				loading: true,
				modal: false,
			});
			this.armSigningWatchdog();
		}

		if (patientIntakeFields.registrationType) {
			this.setState({
				maxProgress:
					patientFinalStep[patientIntakeFields.registrationType] || 15,
			});
		}

		if (patientIntakeFields.url) {
			// Success: the signing URL arrived. Cancel the watchdog and clear any
			// prior error before opening the signing modal.
			this.clearSigningWatchdog();
			this.setState({
				siteUrl: patientIntakeFields.url,
				modal: true,
				loading: false,
				signingError: false,
				signingErrorMessage: '',
			});
			// Start polling as soon as the signing modal opens so a patient who
			// signs INSIDE the embedded iframe (and waits, as the modal copy
			// promises) is still moved on automatically — not only when they use
			// the new-tab fallback. Teardown is centralized/idempotent and the
			// interval guard prevents a double-interval.
			this.startOnboardingPolling();
		} else if (patientIntakeFields.signingError) {
			// A signing or doc-create request failed and the saga surfaced it as a
			// distinct Redux failure flag (slice 2). Clear the spinner and show the
			// error + retry. Gate on the flag ALONE — never on error internals — so
			// an unexpected error shape can't defeat it (the 2026-08-07 defect). The
			// "Uploading Intake Doc" badge and the final-step gate both read the Redux
			// creatingDoc flag, which DOC_CREATE_ERROR already cleared, so a failed
			// create no longer leaves either stuck.
			this.clearSigningWatchdog();
			this.setState({
				loading: false,
				modal: false,
				signingError: true,
				signingErrorMessage:
					patientIntakeFields.signingErrorMessage || SIGNING_ERROR_FALLBACK,
			});
		} else if (
			(this.state.loading &&
				patientIntakeFields.response &&
				patientIntakeFields.response.status >= 400) ||
			patientIntakeFields.code >= 400
		) {
			// Legacy fallback, corrected from `> 400` to `>= 400` (fixes the HTTP
			// 400 case: `400 > 400` was false). Superseded by the signingError
			// branch above once the saga propagates failures, but kept as defense
			// in depth. Necessary but NOT sufficient — it does nothing for
			// timeouts, network errors, or unclassified failures, so it must never
			// be mistaken for, or ship as, the fix.
			this.clearSigningWatchdog();
			this.setState({ loading: false, modal: false, signingError: true });
		}

		if (patientIntakeFields.checks) {
			Object.keys(patientIntakeFields.checks).forEach((fieldName) => {
				this.setState({
					[fieldName]: patientIntakeFields.checks[fieldName],
				});
			});
		}

		if (patientIntakeFields.intakeProgress > 0) {
			let { intakeProgress } = patientIntakeFields;
			if (
				intakeProgress <= maxProgress &&
				this.state.currentProgress !== intakeProgress
			) {
				if (intakeProgress > 4 && this.state.currentProgress === 0) {
					intakeProgress = 4;
				}
				this.setState({ currentProgress: intakeProgress });
				this.scrollTo(0);
			}
		}
	}

	toggle() {
		this.setState((prevState) => ({
			modal: !prevState.modal,
			signingInNewTab: false,
			popupBlocked: false,
			pollTimedOut: false,
		}));
		this.stopOnboardingPolling();
		this.props.checkOnboading();
	}

	isOnboardingComplete = (props = this.props) =>
		!!(
			props.auth &&
			props.auth.loggedInUser &&
			props.auth.loggedInUser.onboardingComplete
		);

	handleOpenInNewTab = () => {
		const handle = window.open(this.state.siteUrl, '_blank', 'noopener');

		// A blocked popup returns null (or an immediately-closed window). Don't
		// start polling into a silent dead-end — surface an actionable message
		// and the raw URL as a manual escape hatch instead.
		if (!handle || handle.closed) {
			this.stopOnboardingPolling();
			this.setState({
				signingInNewTab: false,
				popupBlocked: true,
			});
			return;
		}

		this.setState({
			signingInNewTab: true,
			popupBlocked: false,
		});
		this.startOnboardingPolling();
	};

	handleWindowFocus = () => {
		this.props.checkOnboading();
	};

	startOnboardingPolling = () => {
		if (this.onboardingPollInterval) return;
		// Fresh session — reset the ceiling counter and clear any prior timeout.
		this.pollAttempts = 0;
		if (this.state.pollTimedOut) {
			this.setState({ pollTimedOut: false });
		}
		this.onboardingPollInterval = setInterval(() => {
			this.pollAttempts += 1;
			if (this.pollAttempts > MAX_POLL_ATTEMPTS) {
				// Give up rather than poll forever for an abandoned/blocked
				// session. Surface a "still waiting" state with a recovery hint.
				this.stopOnboardingPolling();
				this.setState({ pollTimedOut: true });
				return;
			}
			this.props.checkOnboading();
		}, ONBOARDING_POLL_MS);
		window.addEventListener('focus', this.handleWindowFocus);
	};

	stopOnboardingPolling = () => {
		if (this.onboardingPollInterval) {
			clearInterval(this.onboardingPollInterval);
			this.onboardingPollInterval = null;
		}
		window.removeEventListener('focus', this.handleWindowFocus);
	};

	nextProgress = (data, component) => (event) => {
		if (event) event.preventDefault();
		// This whole system needs a rework...
		const { currentProgress, maxProgress } = this.state;
		const {
			patientIntakeFields: { registrationType = 'adult' },
			docCreate,
			docSign,
			creatingDoc,
			createDocSuccess,
		} = this.props;

		let step = 1;
		let newCurrentProgress = currentProgress + step;
		const finalStep = patientFinalStep[registrationType];

		if (component) {
			data.id = this.props.auth.loggedInUser.id;
			data.questionnaire = {
				[component]: this.state[component],
			};
			const keys = Object.getOwnPropertyNames(data);
			data.q = keys.join();
		}

		data.intakeProgress =
			newCurrentProgress > maxProgress ? maxProgress : newCurrentProgress;
		data.currentProgress = newCurrentProgress;

		// The follow-up dispatched after this step's save: create the document at the
		// end of the signable steps, request signing past the final step. Computed
		// before the gate so it can be carried through the queue if the click is held.
		let cb;
		if (newCurrentProgress === lastSigningStep + 1) {
			cb = docCreate;
		} else if (newCurrentProgress > finalStep) {
			cb = docSign;
		}

		// Single source of truth: gate the final-step click on the Redux creatingDoc
		// flag (the same one that drives the upload spinner), not a duplicate
		// component flag. While the create is still in flight, hold the click — with
		// its callback — instead of firing docSign against a not-yet-created doc.
		if (currentProgress < maxProgress || !creatingDoc || createDocSuccess) {
			this.saveData(data, cb);

			if (newCurrentProgress > maxProgress) {
				// Blocking spinner is now showing while signing is requested. Arm the
				// watchdog so an unclassified failure can't leave it spinning forever.
				this.setState({ loading: true });
				this.armSigningWatchdog();
			}
		} else {
			this.setState({
				waitingOnDoc: true,
				waitingOnDocData: data,
				waitingOnDocCb: cb,
			});
		}

		if (newCurrentProgress <= maxProgress) {
			this.setState({ currentProgress: newCurrentProgress });
			this.scrollTo(0);
		}
	};

	saveData = (data, cb) => {
		const { patientIntakeForm } = this.props;
		patientIntakeForm(data, cb);
	};

	prevProgress = () => {
		const {
			patientIntakeFields: { registrationType = 'adult' },
		} = this.props;
		const { currentProgress } = this.state;

		let step = 1;
		if (registrationType === 'child' && currentProgress === 15) {
			step = 4;
		}

		this.saveData({ q: 'progress', intakeProgress: currentProgress - step });

		if (currentProgress > 0) {
			this.setState({ currentProgress: currentProgress - step });
		} else {
			window.history.back();
		}

		this.scrollTo(0);
	};

	handleChange = (event) => {
		const { target } = event;
		const { name, value } = target;

		this.setState({ [name]: value });
	};

	handleStateChange = (component) => (event) => {
		const { target } = event;
		event.preventDefault();
		const { name, value } = target;
		// eslint-disable-next-line react/no-access-state-in-setstate
		const componentState = this.state[component];
		componentState[name] = value;
		this.setState({ [component]: componentState });
	};

	handleDateChange = (component, id) => (date) => {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const componentState = this.state[component];
		componentState[id] = moment(date).format('YYYY-MM-DD');
		if (component === 'childBasicInfo' && id === 'dob') {
			if (date) {
				componentState.age = moment().diff(componentState[id], 'years');
			} else componentState.age = '';
		}

		this.setState({ [component]: componentState });
	};

	handleCheck = (component, checkboxGroup, id) => {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const componentData = this.state[component];
		const group = componentData[checkboxGroup];
		const index = findIndex(group, (symptom) => symptom.id === id);
		group[index].isSelected = !group[index].isSelected;
		this.setState({ [component]: componentData });
	};

	handleAcceptance = (key) => {
		const value = this.state[key];

		this.setState({ [key]: !value });
	};

	closeRequestSentModal = () => {
		this.setState({
			signingError: false,
			signingErrorMessage: '',
		});
	};

	handleRetry = () => {
		// A doc-create failure and a signing failure surface through the same error
		// modal but need different retries: recreate the document vs re-request
		// signing. createError (set by DOC_CREATE_ERROR) is the discriminator. Either
		// way, retry re-runs ONLY the failed operation — the per-step saves already
		// persisted the form data, so we never resubmit it or move the patient back.
		if (this.props.patientIntakeFields.createError) {
			// Recreate the document. Progress shows via the non-blocking "Uploading
			// Intake Doc" badge (Redux creatingDoc); a repeat failure re-surfaces
			// DOC_CREATE_ERROR, never a silent spinner — so no blocking spinner and no
			// watchdog here (the watchdog guards the signing spinner only).
			this.setState({
				modal: false,
				signingError: false,
				signingErrorMessage: '',
			});
			this.props.docCreate();
			return;
		}
		// Re-issue ONLY the signing request. Re-arm the watchdog so a repeat failure
		// returns to the error state, never to a silent spinner.
		this.setState({
			loading: true,
			modal: false,
			signingError: false,
			signingErrorMessage: '',
		});
		this.armSigningWatchdog();
		this.props.docSign();
	};

	// --- Signing spinner watchdog (slice 3) ---------------------------------
	// Independent of the error-classification code above by construction: it is
	// a plain timer on the spinner, so it still surfaces an error even if the
	// classification paths regress or a brand-new failure mode appears.

	armSigningWatchdog = () => {
		// Idempotent — clear any existing timer first so a retry can't leave two
		// watchdogs running.
		this.clearSigningWatchdog();
		this.signingWatchdog = setTimeout(
			this.handleSigningWatchdogExpiry,
			SIGNING_WATCHDOG_MS,
		);
	};

	clearSigningWatchdog = () => {
		if (this.signingWatchdog) {
			clearTimeout(this.signingWatchdog);
			this.signingWatchdog = null;
		}
	};

	handleSigningWatchdogExpiry = () => {
		this.signingWatchdog = null;
		// Only fire if still on the blocking spinner and no signing URL arrived.
		// Do NOT touch Redux intake fields and do NOT move currentProgress.
		if (!this.state.loading) return;
		if (this.props.patientIntakeFields.url) return;
		this.setState({
			loading: false,
			modal: false,
			signingError: true,
			signingErrorMessage: WATCHDOG_ERROR_MESSAGE,
		});
	};

	handleGeoChange = (type, selectedItem) => {
		const { doFetchCities, doFetchZipcodes } = this.props;
		switch (type) {
			case 'state':
				doFetchCities(selectedItem.value, selectedItem.label);
				break;

			case 'city':
				doFetchZipcodes(selectedItem.value);
				break;

			default:
				break;
		}
	};

	getStep(progress) {
		const {
			patientIntakeFields: { registrationType = 'adult' },
			patientIntakeFields,
			geo,
			auth,
			states,
			cities,
			zipcodes,
			isMobile,
			doFetchCities,
			doFetchZipcodes,
		} = this.props;
		const { loggedInUser } = this.props.auth;
		const { authorizeToSharePHIChecked, authorizeToSharePHINotSignedDescribe } =
			this.state;

		const steps = this.getStepListByUserType();
		const currentStepName = steps[progress];

		switch (currentStepName) {
			case STEPS.Primary:
				return (
					<PrimaryCareIntake
						handleAcceptance={this.handleAcceptance}
						patientIntakeFields={patientIntakeFields}
						primaryCareChecked={this.state.primaryCareChecked}
						therapistChecked={this.state.therapistChecked}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						geo={geo}
						auth={auth}
						states={states}
						cities={cities}
						zipcodes={zipcodes}
						handleGeoChange={this.handleGeoChange}
						isMobile={isMobile}
					/>
				);
			case STEPS.Insurance:
				return (
					<InsuranceIntake
						handleAcceptance={this.handleAcceptance}
						patientIntakeFields={patientIntakeFields}
						insuranceInformationreChecked={
							this.state.insuranceInformationreChecked
						}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						isMobile={isMobile}
					/>
				);
			case STEPS.Acknowledgement:
				return (
					<Acknowledgements
						handleAcceptance={this.handleAcceptance}
						cancellationPolicyChecked={this.state.cancellationPolicyChecked}
						returnedCheckChecked={this.state.returnedCheckChecked}
						delinquentAccountsChecked={this.state.delinquentAccountsChecked}
						limitaionsOfConfidentialityChecked={
							this.state.limitaionsOfConfidentialityChecked
						}
						mobileMsgFaxEmailChecked={this.state.mobileMsgFaxEmailChecked}
						MessagesChecked={this.state.MessagesChecked}
						emergencyAccessChecked={this.state.emergencyAccessChecked}
						consentForTreatmentChecked={this.state.consentForTreatmentChecked}
						electronicRecordChecked={this.state.electronicRecordChecked}
						billingChecked={this.state.billingChecked}
						infoRelatedTreatmentChecked={this.state.infoRelatedTreatmentChecked}
						patientAgreementChecked={this.state.patientAgreementChecked}
						openPaymentChecked={this.state.openPaymentChecked}
						goodFaithEstimateChecked={this.state.goodFaithEstimateChecked}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						isMobile={isMobile}
					/>
				);
			case STEPS.Financial:
				return (
					<FinancialAgreementIntake
						handleAcceptance={this.handleAcceptance}
						financialAgreementChecked={this.state.financialAgreementChecked}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						isMobile={isMobile}
					/>
				);
			case STEPS.Payment:
				return (
					<PatientPayment
						handleAcceptance={this.handleAcceptance}
						patientIntakeFields={patientIntakeFields}
						patientPaymentDetailsChecked={
							this.state.patientPaymentDetailsChecked
						}
						patientPaymentAgreementChecked={
							this.state.patientPaymentAgreementChecked
						}
						sameAsMainAddress={this.state.sameAsMainAddress}
						useCreditCard={this.state.useCreditCard}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						isMobile={isMobile}
						states={states}
						cities={cities}
						zipcodes={zipcodes}
						fetchCities={doFetchCities}
						fetchZipcodes={doFetchZipcodes}
					/>
				);
			case STEPS.IopIntake:
				return (
					<IopIntake
						handleAcceptance={this.handleAcceptance}
						patientIntakeFields={patientIntakeFields}
						IOPChecked={this.state.IOPChecked}
						IOPAgreementChecked={this.state.IOPAgreementChecked}
						guarantorChecked={this.state.guarantorChecked}
						useCreditCard={this.state.useCreditCard}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						isMobile={isMobile}
					/>
				);
			case STEPS.Privacy:
				return (
					<PrivacyPracticesIntake
						handleAcceptance={this.handleAcceptance}
						handleChange={this.handleChange}
						privacyPracticesChecked={this.state.privacyPracticesChecked}
						privacyNoticeNotSignedDescribe={
							this.state.privacyNoticeNotSignedDescribe
						}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						isMobile={isMobile}
					/>
				);
			case STEPS.Phi:
				return (
					<AuthorizeToSharePHI
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						authorizeToSharePHIChecked={authorizeToSharePHIChecked}
						authorizeToSharePHINotSignedDescribe={
							authorizeToSharePHINotSignedDescribe
						}
						handleAcceptance={this.handleAcceptance}
						handleChange={this.handleChange}
						isMobile={isMobile}
					/>
				);
			case STEPS.Telehealth:
				return (
					<Telehealth
						handleAcceptance={this.handleAcceptance}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						telehealthChecked={this.state.telehealthChecked}
						isMobile={isMobile}
					/>
				);
			case STEPS.Group:
				return (
					<GroupStandards
						handleAcceptance={this.handleAcceptance}
						patientDetail={registrationType}
						nextProgress={this.nextProgress}
						prevProgress={this.prevProgress}
						groupStandardsChecked={this.state.groupStandardsChecked}
						isMobile={isMobile}
					/>
				);
			case STEPS.ChildInfo:
				return (
					<ChildBasicInfo
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						data={this.state.childBasicInfo}
						handleChange={this.handleStateChange}
						handleDateChange={this.handleDateChange}
						isMobile={isMobile}
					/>
				);
			case STEPS.Questionnaire:
				return (
					<IntakeQuestionnaire
						patientIntakeFields={patientIntakeFields}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						isMobile={isMobile}
					/>
				);
			case STEPS.Behavioral:
				return (
					<BehavioralGuidelines
						behavioralGuideLinesChecked={this.state.behavioralGuideLinesChecked}
						handleAcceptance={this.handleAcceptance}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						isMobile={isMobile}
					/>
				);
			case STEPS.ChidlAppointmentReason:
				return (
					<ChildAppointmentReason
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						data={this.state.childAppointmentReason}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultMedical:
				return (
					<AdultMedical
						patientIntakeFields={patientIntakeFields}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						data={this.state.adultMedical}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						handleDateChange={this.handleDateChange}
						isMobile={isMobile}
					/>
				);
			case STEPS.DrugAlcohol:
				return (
					<DrugAlcoholPolicy
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						drugAlcoholPolicyChecked={this.state.drugAlcoholPolicyChecked}
						handleAcceptance={this.handleAcceptance}
						isMobile={isMobile}
					/>
				);
			case STEPS.ChildAdhdInfo:
				return (
					<ChildAdhdInfo
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						data={this.state.childAdhdInfo}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultMedicalContinued:
				return (
					<AdultMedicalContinued
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.adultMedicalContinued}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.ChildSleepHabits:
				return (
					<ChildSleepHabits
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.childSleepHabits}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultSleepHabits:
				return (
					<AdultSleepHabits
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.adultSleepHabits}
						handleChange={this.handleStateChange}
						isMobile={isMobile}
					/>
				);
			case STEPS.Consent:
				return (
					<GroupTherapyConsentFrom
						name={loggedInUser.name}
						handleAcceptance={this.handleAcceptance}
						groupTherapyConsentFormChecked={
							this.state.groupTherapyConsentFormChecked
						}
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						patientDetail={patientIntakeFields.registrationType}
						isMobile={isMobile}
					/>
				);
			case STEPS.ChildOtherIntake:
				return (
					<ChildOtherIntake
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.childOtherIntake}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
						isUploading={this.props.creatingDoc}
					/>
				);
			case STEPS.Substance:
				return (
					<AdultSubstanceAbuse
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.adultSubstanceAbuse}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultPsychiatricHistory:
				return (
					<AdultPsychiatricHistory
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={
							this.state.adultPsychiatricHistory ||
							stateFields.adultPsychiatricHistory
						}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultMedicalHistory:
				return (
					<AdultMedicalHistory
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={
							this.state.adultMedicalHistory || stateFields.adultMedicalHistory
						}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
					/>
				);
			case STEPS.AdultOtherHistory:
				return (
					<AdultOtherHistory
						prevProgress={this.prevProgress}
						nextProgress={this.nextProgress}
						auth={auth}
						data={this.state.adultOtherHistory || stateFields.adultOtherHistory}
						handleChange={this.handleStateChange}
						handleCheck={this.handleCheck}
						isMobile={isMobile}
						isUploading={this.props.creatingDoc}
					/>
				);

			default:
				return <div>Invalid Step</div>;
		}
	}

	getStepListByUserType = () => {
		const {
			patientIntakeFields: { registrationType = 'adult' },
		} = this.props;
		let steps = [];

		switch (registrationType) {
			case 'iopPhp':
				steps = iopPhpSteps;
				break;
			case 'child':
				steps = childSteps;
				break;
			case 'adult':
			default:
				steps = adultSteps;
				break;
		}

		return steps;
	};

	scrollTo = (value) => {
		document.body.scrollTo({ top: value, behavior: 'smooth' });
	};

	render() {
		const { isMobile } = this.props;
		const headerHeight = isMobile ? 60 : 100;
		const { currentProgress, maxProgress } = this.state;
		const { loggedInUser } = this.props.auth;

		return (
			<div className="position-relative">
				{this.props.creatingDoc && (
					<div
						className="row"
						style={{ position: 'fixed', top: 110, right: 40 }}
					>
						<div className="col-auto px-0 pr-2 link-color">
							Uploading Intake Doc
						</div>
						<div className="col-auto px-0">
							<SmallLoadingIndicator
								color="var(--main-color)"
								className=""
								style={{ width: '20px', height: '20px', marginTop: '4px' }}
							/>
						</div>
					</div>
				)}
				{this.state.loading && <LoadingIndicator />}
				{this.state.signingError && (
					<StatusModal
						successStatus={false}
						hide={this.closeRequestSentModal}
						onRetry={this.handleRetry}
						retryLabel="Try Again"
						message={this.state.signingErrorMessage || SIGNING_ERROR_FALLBACK}
					/>
				)}
				<div
					className="w-100 sticky"
					style={{ position: 'sticky', top: 0, zIndex: 1000 }}
				>
					<CommonHeader
						routeProps={this.props}
						user={loggedInUser}
						name="Patient Intake and Consent"
						height={headerHeight}
						isMobile={isMobile}
					/>
					<Progress
						className="prog"
						color="success"
						value={(currentProgress / maxProgress) * 100}
					/>
				</div>
				<div className="content" style={{ width: '100vw' }}>
					{!isProduction && (
						<div
							style={{
								position: 'fixed',
								right: 20,
								zIndex: 100,
							}}
						>
							<button
								className="card"
								style={{ color: 'var(--main-color)' }}
								onClick={() => this.scrollTo(0)}
							>
								&#9650;
							</button>
							<button
								className="card"
								style={{ color: 'var(--main-color)' }}
								onClick={() => this.scrollTo(document.body.scrollHeight)}
							>
								&#9660;
							</button>
						</div>
					)}
					<div
						className={`container ${isMobile && 'px-0'}`}
						style={{ minHeight: window.innerHeight - headerHeight - 64 }}
					>
						{this.getStep(currentProgress)}
					</div>
					<Footer />
				</div>
				<SigningModal
					isOpen={this.state.modal}
					siteUrl={this.state.siteUrl}
					toggle={this.toggle}
					onOpenInNewTab={this.handleOpenInNewTab}
					popupBlocked={this.state.popupBlocked}
					pollTimedOut={this.state.pollTimedOut}
				/>
			</div>
		);
	}
}

Intake.propTypes = {
	patientIntakeForm: PropTypes.func.isRequired,
	patientIntakeFields: PropTypes.object.isRequired,
	patientIntakeFetchData: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
	checkOnboading: PropTypes.func.isRequired,
	doSetPrevPath: PropTypes.func.isRequired,
	geo: PropTypes.object.isRequired,
	states: PropTypes.array,
	cities: PropTypes.object,
	zipcodes: PropTypes.object,
	doFetchStates: PropTypes.func.isRequired,
	doFetchCities: PropTypes.func.isRequired,
	doFetchZipcodes: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
	patientRegister: makeSelectPatientRegister(),
	patientIntakeFields: makeSelectPatientIntake(),
	createDocSuccess: makeSelectCreateDocSuccess(),
	creatingDoc: makeSelectCreatingDoc(),
	states: makeSelectStates(),
	cities: makeSelectCities(),
	zipcodes: makeSelectZipcodes(),
	auth: makeSelectAuth(),
	geo: makeSelectGeo(),
	isMobile: makeSelectIsMobile(),
});

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		patientIntakeForm: (data, cb) => dispatch(patientIntake(data, cb)),
		docCreate: () => dispatch(docCreate()),
		docSign: () => dispatch(docSign()),
		patientIntakeFetchData: (data) => dispatch(fetchData(data)),
		checkOnboading: () => dispatch(checkOnboading()),
		doSetPrevPath: (data) => dispatch(setPrevPath(data)),
		doFetchStates: () => dispatch(fetchStates()),
		doFetchCities: (stateCode, stateName) =>
			dispatch(fetchCities(stateCode, stateName)),
		doFetchZipcodes: (cityName) => dispatch(fetchZipcodes(cityName)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Intake);
